import { WhatsAppOutlined } from '@ant-design/icons';
import { M, G } from '../shared/constants';

export function MembershipCard({ profile }) {
  if (!profile) return null;
  const printCard = () => {
    const cardEl = document.getElementById('membership-card-print');
    if (!cardEl) return;
    const win = window.open('', '_blank');
    win.document.write(`<html><head><title>ABRSVS Member Card</title><style>*{-webkit-print-color-adjust:exact!important;print-color-adjust:exact!important;box-sizing:border-box;}@page{size:A6 landscape;margin:8mm;}body{margin:0;display:flex;align-items:center;justify-content:center;min-height:100vh;background:#f3f4f6;font-family:'Segoe UI','Noto Sans Devanagari',sans-serif;}#membership-card-print{width:128mm;max-width:128mm;}@media print{body{margin:0;background:#fff;min-height:unset;}#membership-card-print{width:128mm;max-width:128mm;border-radius:6mm;}}</style></head><body>${cardEl.outerHTML}<script>window.onload=()=>window.print();<\/script></body></html>`);
    win.document.close();
  };

  return (
    <div style={{ marginBottom: 16 }}>
      {/* Card */}
      <div id="membership-card-print" style={{
        background: `linear-gradient(135deg, #7a0000 0%, #b71c1c 55%, #7a0000 100%)`,
        borderRadius: 16, color: '#fff',
        boxShadow: '0 8px 32px rgba(122,0,0,0.4)',
        position: 'relative', overflow: 'hidden',
      }}>
        {/* Decorative circles */}
        <div style={{ position: 'absolute', right: -30, top: -30, width: 140, height: 140, borderRadius: '50%', background: 'rgba(255,255,255,0.06)' }} />
        <div style={{ position: 'absolute', right: 40, bottom: -40, width: 100, height: 100, borderRadius: '50%', background: 'rgba(255,255,255,0.05)' }} />
        <div style={{ position: 'absolute', left: -20, bottom: -20, width: 80, height: 80, borderRadius: '50%', background: 'rgba(255,255,255,0.04)' }} />

        {/* Top header bar */}
        <div style={{ background: 'rgba(0,0,0,0.25)', padding: '10px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <div style={{ fontSize: 10, fontWeight: 900, color: G, letterSpacing: 2 }}>ABRSVS</div>
            <div style={{ fontSize: 8, color: 'rgba(255,255,255,0.6)', marginTop: 1 }}>अखिल भारतीय राजपुरोहित समाज विकास संस्थान</div>
          </div>
          <div style={{ textAlign: 'right' }}>
            <div style={{ fontSize: 8, color: 'rgba(255,255,255,0.5)', letterSpacing: 1 }}>MEMBER CARD</div>
            <div style={{ fontSize: 8, background: '#15803d', color: '#fff', borderRadius: 20, padding: '1px 7px', marginTop: 2, fontWeight: 700 }}>● ACTIVE</div>
          </div>
        </div>

        {/* Main content */}
        <div style={{ padding: '14px 16px' }}>
          <div style={{ display: 'flex', gap: 14, alignItems: 'flex-start' }}>
            {/* Photo */}
            {profile.photo
              ? <img src={profile.photo} alt={profile.name} style={{ width: 64, height: 64, borderRadius: 10, objectFit: 'cover', objectPosition: 'top', border: '2px solid rgba(253,230,138,0.7)', flexShrink: 0 }} />
              : <div style={{ width: 64, height: 64, borderRadius: 10, background: 'rgba(255,255,255,0.15)', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22, fontWeight: 900, color: G, border: '2px solid rgba(253,230,138,0.7)' }}>
                  {(profile.name || '?')[0].toUpperCase()}
                </div>
            }
            {/* Name & details */}
            {(() => {
              const addr = profile.perm_address || {};
              const village  = addr.village  || null;
              const tahsil   = addr.tahsil   || null;
              const district = addr.district  || null;
              const state    = addr.state     || null;
              const father   = profile.father_name && profile.father_name !== 'null' ? profile.father_name : null;
              return (
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 17, fontWeight: 900, color: '#fff', lineHeight: 1.2, marginBottom: 6 }}>{profile.name_hn || profile.name || '—'}</div>
                  {father   && <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.8)', marginBottom: 2 }}>पिता : {father}</div>}
                  {profile.gotra && <div style={{ fontSize: 10, color: G, fontWeight: 700, marginBottom: 4 }}>गोत्र : {profile.gotra}</div>}
                  <div style={{ borderTop: '1px solid rgba(255,255,255,0.15)', paddingTop: 6, marginTop: 2 }}>
                    {village  && <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.7)', marginBottom: 1 }}>ग्राम : {village}{tahsil ? `, तहसील : ${tahsil}` : ''}</div>}
                    {district && <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.7)', marginBottom: 1 }}>जिला : {district}{state ? `, ${state}` : ''}</div>}
                  </div>
                </div>
              );
            })()}
          </div>
        </div>

        {/* Bottom gold strip */}
        <div style={{ background: 'rgba(0,0,0,0.3)', borderTop: `1px solid ${G}40`, padding: '8px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <div style={{ fontSize: 7, color: 'rgba(255,255,255,0.45)', letterSpacing: 1, marginBottom: 1 }}>MEMBER NO.</div>
            <div style={{ fontSize: 14, fontWeight: 900, color: G, letterSpacing: 2 }}>{profile.membership_no || (profile.id ? `ID-${profile.id}` : '—')}</div>
          </div>
          <div style={{ width: 1, height: 28, background: 'rgba(255,255,255,0.15)' }} />
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 7, color: 'rgba(255,255,255,0.45)', letterSpacing: 1, marginBottom: 1 }}>SINCE</div>
            <div style={{ fontSize: 14, fontWeight: 900, color: '#fff' }}>
              {profile.joining_date ? new Date(profile.joining_date).getFullYear() : '—'}
            </div>
          </div>
          <div style={{ width: 1, height: 28, background: 'rgba(255,255,255,0.15)' }} />
          <div style={{ textAlign: 'right' }}>
            <div style={{ fontSize: 7, color: 'rgba(255,255,255,0.45)', letterSpacing: 1, marginBottom: 1 }}>VALID</div>
            <div style={{ fontSize: 11, fontWeight: 800, color: G }}>LIFETIME</div>
          </div>
        </div>
      </div>

      {/* Actions */}
      <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
        <button onClick={printCard} style={{
          flex: 1, background: '#f3f4f6', border: '1px solid #e5e7eb', borderRadius: 9,
          padding: '8px 0', fontSize: 12, fontWeight: 700, cursor: 'pointer', color: '#374151',
          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 5,
        }}>
          🖨️ Print / Download
        </button>
        <button onClick={() => {
          const msg = `🙏 *ABRSVS Member Card*\n\nनाम: ${profile.name_hn || profile.name}\nसदस्य क्र.: ${profile.membership_no || '-'}\nगोत्र: ${profile.gotra || '-'}\nसदस्यता: ${profile.joining_date ? new Date(profile.joining_date).getFullYear() : '-'} से`;
          window.open(`https://wa.me/?text=${encodeURIComponent(msg)}`, '_blank');
        }} style={{
          flex: 1, background: '#25d366', border: 'none', borderRadius: 9,
          padding: '8px 0', fontSize: 12, fontWeight: 700, cursor: 'pointer', color: '#fff',
          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 5,
        }}>
          <WhatsAppOutlined /> Share
        </button>
      </div>
    </div>
  );
}
